export default {
  // confirm info/warning
  confirm_Info_Warning: 0,

  // confirm yes_no
  confirm_Yes_No: 1,

  // confirm yes_no_cancel
  confirm_Yes_No_Cancel: 2,

  // confirm delete
  confirm_Delete: 3,

  // confirm Đóng
  confirm_Close: 4,

  // Chỉ nhận thông báo là text
  confirmOnlyTextForm: 12,

  // Xác nhận tự động hạch toán đồng thời
  confirmAutoGenerateParallel: 10,

  // Xác nhận đã phát sinh dữ liệu
  confirmIncurredData: 20,

  // xác nhận mapping chứng từ hồ sơ
  confirmMappingVoucher: 21,
};
